module.exports = __webpack_public_path__ + "static/media/AF.67dec2f0.webp";